import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import reportWebVitals from './reportWebVitals';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './queryClient';

//router
import { RouterProvider, createBrowserRouter } from "react-router-dom";

//store

import { Provider } from "react-redux";
//reducer
import { store } from "./store/index";
import { IndexRouters } from "./router";

import './datatablesDefaults'; // DataTables 기본 설정 가져오기
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const router = createBrowserRouter(
  [
    ...IndexRouters,
  ],
  { basename: process.env.PUBLIC_URL }
);
ReactDOM.createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App>
          <RouterProvider router={router}></RouterProvider>
        </App>
      </QueryClientProvider>
      <ToastContainer position="top-right" autoClose={3000} />
    </Provider>
  </StrictMode>
);